import { render } from "./photoSwipeGallery.vue?vue&type=template&id=45c4e43b"
import script from "./photoSwipeGallery.vue?vue&type=script&lang=js"
export * from "./photoSwipeGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__